import React from "react";
import ReactDOM from "react-dom";
import App from "./components/Main";
//import App from "./components/utils/TextoAutocompletar";
//import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

//serviceWorker.unregister();
